import React, { useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Link } from 'react-router-dom';
import { styled } from '@mui/system';
import { Menu, MenuItem } from '@mui/material';
import { DeleteRounded, Edit } from '@mui/icons-material';
import DeleteWarehouseDialog from '#component/addressbook/dashboard/delete-addressbook-dialog';
import { deleteWarehouse } from '#action/warehouse/warehouse';
import { fetchWarehousesAndAppliances } from '#action/warehouse/warehouses';

const StyledEditIcon = styled(Edit)(({ theme }) => ({
  color: 'rgba(0, 0, 0, 0.54)',
  marginRight: theme.spacing()
}));

const StyledDeleteIcon = styled(DeleteRounded)(({ theme }) => ({
  color: 'rgba(0, 0, 0, 0.54)',
  marginRight: theme.spacing()
}));

/**
 * Renders a warehouse actions and delete dialog.
 * @returns {React.FC}
 */

const WarehouseActions = props => {
  const { anchorEl, setAnchorEl = () => null, warehouse } = props;
  const account = useSelector(s => s.account, shallowEqual);
  const { userType } = account;
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDeleteClick = () => {
    setOpen(true);
  };

  const handleDeleteClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const handleDelete = async () => {
    const result = await dispatch(deleteWarehouse(warehouse?.id));
    if (result?.success) {
      handleDeleteClose();
      dispatch(fetchWarehousesAndAppliances());
    }
  };

  return (
    <>
      {userType < 10 &&
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          component={Link}
          to={`/warehouse/edit/${warehouse?.id}`}
        >
          <StyledEditIcon />
          Edit
        </MenuItem>
        <MenuItem onClick={handleDeleteClick}>
          <StyledDeleteIcon />
          Delete
        </MenuItem>
      </Menu>}
      <DeleteWarehouseDialog
        open={open}
        dialogTitle={`Do you want to delete the "${warehouse?.label ?? ''}"?`}
        entityTitle={warehouse?.label ?? ''}
        dialogContentText="Type the site label to confirm"
        textFieldLabel="Label"
        onClose={handleDeleteClose}
        onDelete={handleDelete}
      />
    </>
  );
};

export default WarehouseActions;
